"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldUseLightText = void 0;
/**
 * calculateYIQ uses the luma conversion formula to calculate the relative luminescence of a color.
 * see https://en.wikipedia.org/wiki/YIQ
 * @param hexColor: rgb color
 * @returns number: YIQ = (Y)luminance (IQ)chrominance for the RGB colour provided
 */
var calculateYIQ = function (hexcolor) {
    var _a, _b, _c;
    var rgb = hexcolor.replace(/[^0-9\,]/g, ''); // remove everything except numbers and commas
    var split = rgb.split(',');
    var r = parseInt((_a = split[0]) !== null && _a !== void 0 ? _a : 0, 16);
    var g = parseInt((_b = split[1]) !== null && _b !== void 0 ? _b : 0, 16);
    var b = parseInt((_c = split[2]) !== null && _c !== void 0 ? _c : 0, 16);
    var yiq = (r * 0.299 + g * 0.587 + b * 0.114) / 1000;
    return yiq;
};
var shouldUseLightText = function (_a) {
    var progressBarFilledColor = _a.progressBarFilledColor, progressBarUnfilledColor = _a.progressBarUnfilledColor, progress = _a.progress;
    var textBackground = progress > 50 ? progressBarFilledColor : progressBarUnfilledColor;
    // This matches the hexadecimal 138 value suggested by Vlad Gutkovsky see https://www.infinityinsight.com/blog/?p=411
    var DARK_YIQ = 0.31;
    return calculateYIQ(textBackground) < DARK_YIQ;
};
exports.shouldUseLightText = shouldUseLightText;
//# sourceMappingURL=ProgressBarHelpers.js.map